<template>
  <div class="myIntegral">
    <van-nav-bar
      :title="title"
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="myIntegral_buttonBox">
      <div class="myIntegral_button" @click="goRecord">积分记录</div>
    </div>
    <div class="myIntegral_detail">
      <div class="myIntegral_detail_left">
        <img
          :src="headImg"
          class="myIntegral_detail_man"
        />
        <p>{{ name }}</p>
      </div>
      <div class="myIntegral_detail_right">
        <img
          src="@/assets/images/integral/money.png"
          class="myIntegral_detail_money"
        />
        <p>X{{ moneyNum }}</p>
      </div>
    </div>
    <p class="myIntegral_bot">累计积分，可以兑换礼物，敬请期待哦~</p>
  </div>
</template>
<script>
import { verticalScreen } from "../../assets/js/vertical-screen";
import { _getUserIntegral } from "../../api/integral";
import { decryptBy } from '@/assets/js/encryption';
export default {
  name: 'my-integral',
  data() {
    return {
      title: "我的积分",
      name: "张三",
			headImg:'',
      moneyNum: 3000,
			list:[],
			userId:'',
      male:require('./../../assets/images/family-archives/male.png'),
			female:require('./../../assets/images/family-archives/female.png'),
    };
  },
	mounted() {
		let parentsInfor = JSON.parse(decryptBy(localStorage.getItem("parentsInfor")));
		this.name = parentsInfor.parentName;
    if(parentsInfor.headImg) {
      this.headImg = parentsInfor.headImg;
      // this.headImg = 'http://172.16.12.229:9100/' + parentsInfor.headImg;
    } else {
      this.headImg = parentsInfor.sex === 1 ? this.male : this.female;
    }
		let info = localStorage.getItem("userInfo");
    let user = JSON.parse(decryptBy(info));
    verticalScreen();
		this.getUserIntegral(user.userId);
		this.userId = user.userId;
  },
  methods: {
		// 返回
    onClickLeft() {
      this.$router.push("/");
    },
		// 获取积分
    getUserIntegral(userId) {
      _getUserIntegral({
					"currentPage": 1,
					"pageSize": 1,
					"queryData": {
        		userId: userId,				
					},
      }).then((res) => {
        if (res && res.code == 200) {
          let rows = res.data; //请求返回当页的列表
					this.moneyNum = rows.allScore;
					this.list = rows.list;
        } else {
          this.$toast(res.message);
        }
      });
    },
		// 跳转积分记录页
    goRecord() {
      this.$router.push("integralRecord");
			this.$router.push({
				name:'integral-record',
				query:{
					list:this.list,
					userId:this.userId
				}
			})
    },
  },
};
</script>
<style lang="scss" scoped>
.myIntegral {
  .myIntegral_buttonBox {
    display: flex;
    justify-content: flex-end;
    .myIntegral_button {
      width: 85px;
      height: 28px;
      background: linear-gradient(360deg, #ff7f30 0%, #ffbc97 100%);
      border-radius: 15px;
      color: #fff;
      text-align: center;
      line-height: 28px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin: 15px 15px 20px 0;
    }
  }
  .myIntegral_detail {
    width: 345px;
    height: 108px;
    margin-left: 15px;
    background: url(./../../assets/images/integral/integral-bg.png);
    background-size: cover;
    display: flex;
    justify-content: space-between;
    .myIntegral_detail_left {
      display: flex;
      .myIntegral_detail_man {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin: 24px 18px 0 22px;
      }
      p {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 108px;
      }
    }
    .myIntegral_detail_right {
      display: flex;
      .myIntegral_detail_money {
        width: 36px;
        height: 35px;
        margin-top: 36px;
        margin-right: 4px;
      }
      p {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff5151;
        line-height: 108px;
        margin-right: 32px;
      }
    }
  }
  .myIntegral_bot {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: center;
    margin-top: 20px;
  }
  ::v-deep .van-icon {
    color: #000;
  }
}
</style>